import React, {useEffect, useState, useRef} from 'react';
import { clearPersistedFeedFilters } from './feedFilterPersistence';
import { COUNTRY_NAMES } from '../../utils/countries';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import {useDispatch, useSelector} from 'react-redux';
import {useDrag} from 'react-dnd';
import {
    clearSearchParams,
    setSearchParam, setSelectedBriefLanguage,
    setSelectedCategories,
    setSelectedLanguages,
    setExcludeLanguages,
    setExcludeCountries,
    setSelectedCountries,
    setCountryCoverageMode,
    setLanguageCoverageMode,
    setSelectedPublishers, setSelectedTimeRange, setStoriesFromDate,setExcludeAlreadyMadeStories,setPrs,
    setSignalsOnly,
    setVerifiedBySourcesToggle,
    setMinSourcesVerified,
    setSentimentFilter,
    setAdvancedSort,
    setFeedSourceFilter,
    triggerExpandAll,
    DEFAULT_SEARCH_PARAMS
} from './slice';
import {api} from "../../app/http-common";
import {convertTimeRangeToDateRange, extractKeywords, getSearchTitle, makeLabel} from "./transformers";
import {selectPristine, selectSearchParams} from "../../app/store"; // Adjust imports based on your project structure
import './SearchFields.css';
import { useIsAdmin } from '../../hooks/useFrontegg';
import { STORY_BUCKET_TYPE } from './BucketSidebar';

import TimeRangeSlider from "./TimeRangeSlider";

const SearchFields = ({
                          onSearchSubmit ,
                          onSearchClear ,
                          onClearSelectedArticles,
                          categories ,
                          languages,
                          excludeTheme,
                          withSearchFields,
                          title1,
                          storyId,
                          articlesNumber,
                          claimsNumber,
                          selectedArticles,
                          currentStep,
                          hasExtraStoryArticles,
                      }) => {
    const isAdmin = useIsAdmin();
    const dispatch = useDispatch();
    const [selectedPublisher, setSelectedPublisher] = useState('');
    const [queryHistory, setQueryHistory] = useState([]);
    const [selectedQuery, setSelectedQuery] = useState(null);
    const {
        keywords,
        selectedPublishers,
        dateRange,
        selectedCategories,
        selectedLanguages,
        excludeLanguages,
        excludeCountries,
        selectedCountries,
        countryCoverageMode,
        selectedTimeRange,
        storiesFromDate,
        excludeAlreadyMadeStories,
        signalsOnly,
        prs,
        verifiedBySourcesToggle,
        minSourcesVerified,
        sentimentFilter,
        advancedSort,
        feedSourceFilter,
    } = useSelector(selectSearchParams);
    const pristine = useSelector(selectPristine);
    const storiesAllExpanded = useSelector((state) => state.articles.storiesAllExpanded);
    const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);

    // Drag ref for story title → bucket sidebar
    const titleDragRef = useRef(null);
    const [{ isDraggingTitle }, titleDrag] = useDrag({
        type: STORY_BUCKET_TYPE,
        item: { storyId, title: title1 },
        canDrag: () => !!storyId && !!title1,
        collect: (monitor) => ({ isDraggingTitle: monitor.isDragging() }),
    });
    titleDrag(titleDragRef);
    
    // The country list is the shared registry (src/utils/countries.js), mirrored
    // from backend/utils/countries.js with a drift guard. It used to be a hand-
    // maintained array here that had drifted both ways: it offered countries the
    // corpus has never carried, and omitted ones publishers are assigned to —
    // and because the filter is a raw string match, a name that exists only in
    // this list returns an empty feed rather than reporting a bad filter.
    const availableCountries = COUNTRY_NAMES;

    // A real country/language criterion is active. Mirrors how the query is
    // built: an empty language selection AND a fully-selected one both mean
    // "no language filter" and are sent as ['none'].
    const allLanguageCount = Array.isArray(languages) ? languages.length : 0;
    const hasCoverageCriterion =
        selectedCountries.length > 0
        || (selectedLanguages.length > 0 && selectedLanguages.length !== allLanguageCount);


    useEffect(() => {
        if (new URLSearchParams(window.location.search).get('designFixture') === '1') {
            setQueryHistory([{ _id: 'fixture-q1', keywords: ['social media'], categories: ['Technology'], timeRange: 'Last 24 Hours', languages: ['English'] }]);
            return;
        }
        const fetchQueryHistory = async () => {
            try {
                const response = await api.queries();
                const data = Array.isArray(response) ? response : Array.isArray(response?.data) ? response.data : [];
                setQueryHistory(data);
            } catch (error) {
                console.error('Error fetching query history:', error);
            }
        };
        if (currentStep === 0) {
            fetchQueryHistory();
        }
    }, [currentStep]);

    const getQueryDisplayText = (query) => {
        //const keywords = query.keywords ? query.keywords.map(kw => kw.keyword).join(', ') : 'No keywords';
        const categories = (query.categories && query.categories[0]) || 'No categories';
        const timeRange = query.timeRange || 'No time range';
        const languages = (query.languages && query.languages[0]) || 'No languages';

        return getSearchTitle(query.keywords || [],categories,timeRange,languages==='none'?'All languages':languages)

        //return `${keywords} | ${categories} | ${timeRange} | ${languages}`;
    };

    const handleQuerySelect = (e) => {
        const selectedQueryId = e.target.value;
        const query = Array.isArray(queryHistory) ? queryHistory.find(q => q._id === selectedQueryId) : null;

        if (query) {
            // Dispatch actions to update the search fields with the selected query's values
            //dispatch(setSearchParam(["keywords", query.keywords]));
            let originalValues = [];
            let updatedKeywordsAnd = keywords;
            
            // Ensure query.keywords is an array
            const queryKeywords = Array.isArray(query.keywords) ? query.keywords : [];
            queryKeywords.map(key=> {
                const keyV = {label:key,value:{keyword:key}}
                updatedKeywordsAnd  =  {...updatedKeywordsAnd, ['$and']: [...updatedKeywordsAnd['$and'], JSON.parse(JSON.stringify(keyV))]};
            })
            if (queryKeywords.length) {
                //const updatedKeywordsAnd = {...keywords, ['$and']: [...keywords['$and'], originalValues]};
                dispatch(setSearchParam(["keywords", updatedKeywordsAnd]));
            }
            // Set categories as array
            if (query.categories && Array.isArray(query.categories) && query.categories.length > 0) {
                const validCategories = query.categories.filter(cat => cat !== 'none' && cat !== 'All categories' && cat !== '---');
                dispatch(setSelectedCategories(validCategories));
            }
            
            // Ensure query.languages is an array
            const queryLanguages = Array.isArray(query.languages) ? query.languages : [];
            queryLanguages.map(language=>{
                dispatch(setSelectedLanguages(language==='none'?'All languages':language))
            })
            dispatch(setSelectedTimeRange(query.timeRange));

            setSelectedQuery(query);
        }
    };


    const resetSearchParameters = () => {
        // const today = new Date();
        // const monthAgo = new Date(today.setDate(today.getDate() - 30));
        //
        // const formattedToday = new Date().toISOString().split('T')[0];
        // const formattedMonthAgo = monthAgo.toISOString().split('T')[0];

        dispatch(setSearchParam(["dateRange", convertTimeRangeToDateRange(selectedTimeRange)]));
       // setTimeRange('Last 24 Hours')
       // setDateRange({ dateStart: formattedToday, dateEnd: formattedToday });
        //setDateLimits({ minDate: formattedMonthAgo, maxDate: formattedToday });
    }

    useEffect(() => {
        resetSearchParameters();
    }, []);

    // Utilize the provided promiseOptions function for keyword suggestions
    const removeKeyword = (keyword, operator) => {

        const newOperatorKeywords = keywords[operator].filter((word) => {
            return (word.value.keyword !== keyword.value.keyword || word.value.keywordLoc !== keyword.value.keywordLoc)
        });
        // setKeywords({ ...keywords, ...{ [operator]: newOperatorKeywords } });
        dispatch(setSearchParam(["keywords", { ...keywords, ...{ [operator]: newOperatorKeywords } }]));
    }

    const onSelectedKeyword = async (newValue) => {
        // Prepare the initial part of the update, adding newValue to the $and array.
        // Deep copy newValue to avoid mutating the original object
        const originalValue = JSON.parse(JSON.stringify(newValue));
        const updatedKeywordsAnd = {...keywords, ['$and']: [...keywords['$and'], originalValue]};
        if (selectedPublishers === 'israel-palestine') {
            const tObjHeb = await translateValue(JSON.parse(JSON.stringify(newValue)), 'he');
            const tObjArab = await translateValue(JSON.parse(JSON.stringify(newValue)), 'ar');
            // Now, add the translated value to the $or array based on the initially updated $and structure.
            const updatedKeywordsOr = {
                ...updatedKeywordsAnd,
                ['$hebrew']: [...(updatedKeywordsAnd['$hebrew'] || []), tObjHeb], // Adds tObj1 to $hebrew
                ['$arabic']: [...(updatedKeywordsAnd['$arabic'] || []), tObjArab] // Adds tObj2 to $arabic
            };

            // Dispatch a single action with the fully updated keywords object.
            dispatch(setSearchParam(["keywords", updatedKeywordsOr]));
        }  else {
            dispatch(setSearchParam(["keywords", updatedKeywordsAnd]));
        }

    };

    const translateValue = async (newValue,target) => {

        let translatedValue;
        const tvalue = newValue;
        // Translate the keyword.
        if (tvalue.value.keyword) {
            translatedValue = await translateKeyword(tvalue.value.keyword, target);
            tvalue.value.keyword = translatedValue;
        } else {
            translatedValue = await translateKeyword(tvalue.value.label.eng, target);
            tvalue.value.label.eng = translatedValue;
        }
        //const translatedValue = await translateKeyword(newValue.value.keyword, 'ar');
        const tranlatedValueObj = {
            value:tvalue.value,
            label: makeLabel(tvalue.value)
        };

        return tranlatedValueObj;
    }

    const translateKeyword = async (text,target) => {
        const results = await api.translate({ texts: [text], target });
        return results[0];
    };

    const promiseOptions = async (inputValue) => {
        // Normalize: if input contains whitespace and isn't already quoted, wrap in quotes.
        const normalized = (inputValue || '').trim();
        const needsQuotes = /\s/.test(normalized) && !/^".*"$/.test(normalized);
        const keyword = needsQuotes ? `"${normalized}"` : normalized;

        // Preserve exact user intent (no splitting), but ensure phrases behave like quoted queries.
        return [{ value: { keyword }, label: normalized }];
        
        // The commented code below was splitting search terms into individual keywords
        // const results = await api.suggestConcepts(inputValue);
        // if (results) {
        //     return [
        //         { keyword: inputValue },
        //         { keyword: inputValue, keywordLoc: "body" },
        //         { keyword: inputValue, keywordLoc: "title" },
        //         ...results,
        //     ].map((item) => ({ value: item, label: makeLabel(item) }));
        // }
    };

    const setStoryCompleted = async (_storyId,completed) => {
        await api.setStoryCompleted({storyId:_storyId,completed});
    };

    // const handleDateChange = (e) => {
    //     const { name, value } = e.target;
    //     setDateRange(prev => ({ ...prev, [name]: value }));
    // };


    const handleSubmit = (e) => {
        e.preventDefault();
        onSearchSubmit({
            dateRange,
            selectedPublisher,
        });
        // You can extend this to include keywords or other search parameters
    };

    const makeSelectedKeywords = () => {
        if (keywords) {
            return Object.keys(keywords)
                .map((operator) => {
                    return (
                        <div key={`${operator}-list`}>
                            <p>
                                {keywords[operator].map((word) => (
                                    <span
                                        key={`${typeof word.label === 'object' ? word.label?.eng : word.label}-span`}
                                        onClick={() => removeKeyword(word, operator)}
                                        className='keyword-button'>
                                    {typeof word.label === 'object' ? word.label?.eng : word.label}
                                </span>
                                ))}
                            </p>
                        </div>
                    );
                });
        }
    };

    const handleInputChange = (event) => {
        dispatch(setSearchParam(["queryUrl", event.target.value]));
    };


    const handleClearSearch = () => {
        // §7 — clear the stored filter too, or "Reset All" resets the screen and
        // the next reload brings the old criteria straight back.
        clearPersistedFeedFilters();
        dispatch(clearSearchParams());
        // NOT resetSearchParameters(): it derives dateRange from the
        // `selectedTimeRange` of the render that is still in scope — the value
        // being reset away — so the slider read "Last 24 Hours" while the query
        // still spanned Last Month. Derive it from the default instead.
        dispatch(setSearchParam([
            "dateRange",
            convertTimeRangeToDateRange(DEFAULT_SEARCH_PARAMS.selectedTimeRange),
        ]));
        onSearchClear();
    };

    const handleTimeRangeChange = (newTimeRange) => {
        const _dateRange = convertTimeRangeToDateRange(newTimeRange);
        dispatch(setSelectedTimeRange(newTimeRange))
        //setTimeRange(newTimeRange);
        dispatch(setSearchParam(["dateRange", {...dateRange, dateStart: _dateRange.dateStart,dateEnd:_dateRange.dateEnd}]));
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="keyword-input-container">


                {(!excludeTheme) && withSearchFields && (<div className="form-field">
                    <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Theme</h5>
                    <select
                        value={selectedPublishers}
                        onChange={({target}) => dispatch(setSelectedPublishers(target.value))}
                    >
                        {['none',
                            'israel-palestine',
                            'ukraine-russia',
                            'republican-democratic',
                            'technology',
                            'science',
                            'streaming'].map(pub => (
                            <option key={pub} value={pub}>
                                {pub}
                            </option>
                        ))}
                    </select>
                </div>)}

                {/* Time Range - Figma order: before Category */}
                {withSearchFields && currentStep === 0 && (<h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Time Range</h5>)}
                {withSearchFields && currentStep === 0 &&
                    (
                        <TimeRangeSlider handleTimeRangeChange={handleTimeRangeChange}
                                         defaultValueIndex={selectedTimeRange}/>)}

                {/*
                  * Show only stories whose cluster was CREATED inside the window,
                  * not every story with an article in it. "Selected time range
                  * only" read as though the unchecked state ignored the time
                  * range altogether, which neither state does: both respect the
                  * range, and what differs is what has to fall inside it. The
                  * copy talks about stories breaking rather than about clusters
                  * and article counts, because a reader of the feed has no model
                  * of how we group things and does not need one.
                  */}
                {withSearchFields && currentStep === 0 && (
                    <>
                        {/* The explanation IS the label now. It previously carried both a
                            short title and this sentence underneath, which said the same
                            thing twice in a narrow rail. The sentence is the one that
                            tells a reader what the box does, so the title went.
                            Flex with align-items centre so the box sits against the
                            middle of the wrapped text rather than its first line. */}
                        <label style={{display: 'flex', alignItems: 'center', gap: '6px', margin: '6px 0 8px', fontSize: '11px', color: '#3C4A5E', lineHeight: 1.4, cursor: 'pointer'}}>
                            <input
                                type="checkbox"
                                checked={storiesFromDate}
                                onChange={(e) => dispatch(setStoriesFromDate(e.target.checked))}
                                style={{accentColor: '#FF6B35', margin: 0, flexShrink: 0}}
                            />
                            <span>Hides stories that started earlier and are still getting coverage.</span>
                        </label>
                        {/* Directly beneath it, because the two answer the same question:
                            which slice of the feed am I looking at. It used to sit far
                            below with the completed-stories and PR boxes, which are about
                            housekeeping rather than scope. Tech Blue to match the Trending
                            marker on the rows it produces, so the control and its result
                            read as one feature. */}
                        <label style={{display: 'flex', alignItems: 'center', gap: '6px', margin: '0 0 8px', fontSize: '12px', color: '#3C4A5E', cursor: 'pointer'}}>
                            <input
                                type="checkbox"
                                checked={signalsOnly}
                                onChange={(e) => dispatch(setSignalsOnly(e.target.checked))}
                                style={{accentColor: '#00AEEF', margin: 0, flexShrink: 0}}
                            />
                            <span>Show trending</span>
                        </label>
                    </>
                )}

                {(categories) && (<div className="form-field">
                    <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Category</h5>
                    <Select
                        isMulti
                        options={categories.filter(cat => cat !== 'All categories').map(cat => ({ value: cat, label: cat }))}
                        value={selectedCategories.map(cat => ({ value: cat, label: cat }))}
                        onChange={(selected) => {
                            const values = selected ? selected.map(item => item.value) : [];
                            dispatch(setSelectedCategories(values));
                        }}
                        placeholder="Search categories"
                        closeMenuOnSelect={false}
                        isClearable={false}
                        backspaceRemovesValue={false}
                        hideSelectedOptions={false}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '36px',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                boxShadow: 'none',
                                '&:hover': {
                                    border: '1px solid #00AEEF',
                                    boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                }
                            }),
                            dropdownIndicator: (base) => ({
                                ...base,
                                color: '#e0e0e0',
                                padding: '6px',
                                svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                '&:hover': {
                                    color: '#00AEEF'
                                }
                            }),
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: 'rgba(0,174,239,0.08)',
                                borderRadius: '12px'
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: '#00AEEF',
                                fontWeight: '500'
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: '#00AEEF',
                                '&:hover': {
                                    backgroundColor: '#00AEEF',
                                    color: 'white'
                                }
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                color: state.isSelected ? 'white' : '#333',
                                '&:hover': {
                                    backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                }
                            })
                        }}
                    />

                    {/* Display Selected Categories - Remove this since they show in the select now */}
                    </div>)}

                {/* Keywords Filter */}
                {withSearchFields && currentStep === 0 && (  
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Keywords</h5>
                        <AsyncSelect
                            aria-label="Keyword-Select"
                            controlShouldRenderValue={false}
                            placeholder="Search and add keywords"
                            loadOptions={promiseOptions}
                            onChange={onSelectedKeyword}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: '#999'
                                }),
                                dropdownIndicator: (base) => ({
                                    display: 'none'
                                }),
                                indicatorSeparator: (base) => ({
                                    display: 'none'
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: '#333',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                        
                        {/* Display Selected Keywords */}
                        {keywords && Object.keys(keywords).some(op => keywords[op].length > 0) && (
                            <div style={{ 
                                marginTop: '10px', 
                                padding: '10px', 
                                backgroundColor: '#f5f5f5', 
                                borderRadius: '8px',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '8px'
                            }}>
                                {Object.keys(keywords).map((operator) => 
                                    keywords[operator].map((word) => (
                                        <span key={`${typeof word.label === 'object' ? word.label?.eng : word.label}-${operator}`} style={{
                                            backgroundColor: 'rgba(0,174,239,0.08)',
                                            color: '#00AEEF',
                                            padding: '6px 12px',
                                            borderRadius: '4px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            {typeof word.label === 'object' ? word.label?.eng : word.label}
                                            <button
                                                type="button"
                                                onClick={() => removeKeyword(word, operator)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#00AEEF',
                                                    cursor: 'pointer',
                                                    padding: '0',
                                                    fontSize: '16px',
                                                    lineHeight: '1'
                                                }}
                                            >
                                                ×
                                            </button>
                                        </span>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                )}

                {languages && currentStep === 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Language</h5>
                        <Select
                            isMulti
                            options={languages.map(lang => ({ value: lang, label: lang }))}
                            value={selectedLanguages.length === languages.length ? [] : selectedLanguages.map(lang => ({ value: lang, label: lang }))}
                            onChange={(selected) => {
                                const values = selected ? selected.map(item => item.value) : [];
                                dispatch(setSelectedLanguages(values));
                                // Remove from excluded if being selected
                                const stillExcluded = excludeLanguages.filter(lang => !values.includes(lang));
                                dispatch(setExcludeLanguages(stillExcluded));
                            }}
                            placeholder={selectedLanguages.length === languages.length ? "All languages" : "Search languages"}
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#00AEEF'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(0,174,239,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    '&:hover': {
                                        backgroundColor: '#00AEEF',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                {/* Exclude Languages Filter */}
                {languages && currentStep === 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Exclude Language</h5>
                        <Select
                            isMulti
                            options={languages.map(lang => ({ value: lang, label: lang }))}
                            value={excludeLanguages.map(lang => ({ value: lang, label: lang }))}
                            onChange={(selected) => {
                                const values = selected ? selected.map(item => item.value) : [];
                                dispatch(setExcludeLanguages(values));
                            }}
                            placeholder="Exclude languages"
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #FF6B35',
                                        boxShadow: '0 0 0 2px rgba(255,107,53,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#FF6B35'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(255,107,53,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#FF6B35',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#FF6B35',
                                    '&:hover': {
                                        backgroundColor: '#FF6B35',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#FF6B35' : state.isFocused ? 'rgba(255,107,53,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#FF6B35' : 'rgba(255,107,53,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                {/* §2 — how much of a story has to match.
                    Shown only when a REAL criterion is active. "All languages"
                    is the absence of a language filter, not a language, so it
                    must not reveal the control — the same test the query uses
                    when it sends ['none']. Without this the control appeared on
                    a fresh feed and after Reset All, offering a choice that
                    decided nothing. */}
                {currentStep === 0 && hasCoverageCriterion && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Coverage</h5>
                        <select
                            value={countryCoverageMode || 'mostly'}
                            onChange={(e) => {
                                dispatch(setCountryCoverageMode(e.target.value));
                                dispatch(setLanguageCoverageMode(e.target.value));
                            }}
                            style={{
                                width: '100%',
                                minHeight: '36px',
                                padding: '6px 10px',
                                borderRadius: '8px',
                                border: '1px solid #ddd',
                                background: '#fff',
                                color: '#0B1E3F',
                                fontSize: '13px',
                                fontFamily: "'Inter', sans-serif",
                                cursor: 'pointer',
                            }}
                        >
                            <option value="mostly">Mostly matching (80%)</option>
                            <option value="any">Any matching (1+)</option>
                        </select>
                    </div>
                )}

                {/* Country Filter */}
                {currentStep === 0 && availableCountries.length > 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Country</h5>
                        <Select
                            isMulti
                            options={availableCountries.map(country => ({ value: country, label: country }))}
                            value={selectedCountries.map(country => ({ value: country, label: country }))}
                            onChange={(selected) => {
                                const values = selected ? selected.map(item => item.value) : [];
                                dispatch(setSelectedCountries(values));
                            }}
                            placeholder="Search countries"
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#00AEEF'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(0,174,239,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    '&:hover': {
                                        backgroundColor: '#00AEEF',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                {/* Exclude Country Filter */}
                {currentStep === 0 && availableCountries.length > 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Exclude Country</h5>
                        <Select
                            isMulti
                            options={availableCountries.map(country => ({ value: country, label: country }))}
                            value={excludeCountries.map(country => ({ value: country, label: country }))}
                            onChange={(selected) => {
                                const values = selected ? selected.map(item => item.value) : [];
                                dispatch(setExcludeCountries(values));
                            }}
                            placeholder="Exclude countries"
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #FF6B35',
                                        boxShadow: '0 0 0 2px rgba(255,107,53,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#FF6B35'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(255,107,53,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#FF6B35',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#FF6B35',
                                    '&:hover': {
                                        backgroundColor: '#FF6B35',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#FF6B35' : state.isFocused ? 'rgba(255,107,53,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#FF6B35' : 'rgba(255,107,53,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                {/* News Source Filter */}
                {withSearchFields && currentStep === 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>News Source</h5>
                        <Select
                            isMulti
                            options={[
                                { value: 'all', label: '📋 All Sources' },
                                { value: 'newsapi_preferred', label: '⭐ Preferred Publishers' },
                                { value: 'newsapi_feed', label: '📰 NewsAPI' },
                                { value: 'newsapi_expansion', label: '📁 Category Expansion' },
                                { value: 'newsapi_expansion_concepts', label: '💡 Concept Expansion' },
                            ]}
                            value={feedSourceFilter.length === 0 
                                ? [{ value: 'all', label: '📋 All Sources' }]
                                : feedSourceFilter.map(f => ({
                                    value: f,
                                    label: f === 'newsapi_preferred' ? '⭐ Preferred Publishers' :
                                           f === 'newsapi_feed' ? '📰 NewsAPI' :
                                           f === 'newsapi_expansion' ? '📁 Category Expansion' :
                                           f === 'newsapi_expansion_concepts' ? '💡 Concept Expansion' : f
                                }))
                            }
                            onChange={(selected, actionMeta) => {
                                if (!selected || selected.length === 0) {
                                    // Nothing selected - default to All
                                    dispatch(setFeedSourceFilter([]));
                                } else {
                                    const hasAll = selected.some(s => s.value === 'all');
                                    const wasAllSelected = actionMeta.action === 'select-option' && actionMeta.option?.value === 'all';
                                    
                                    if (wasAllSelected) {
                                        // User clicked "All Sources" - clear specific filters
                                        dispatch(setFeedSourceFilter([]));
                                    } else if (hasAll && selected.length > 1) {
                                        // User selected specific source while All was selected - remove All, keep specific
                                        const specificSources = selected.filter(s => s.value !== 'all').map(s => s.value);
                                        dispatch(setFeedSourceFilter(specificSources));
                                    } else {
                                        // Normal multi-select of specific sources
                                        dispatch(setFeedSourceFilter(selected.filter(s => s.value !== 'all').map(s => s.value)));
                                    }
                                }
                            }}
                            placeholder="Select news sources"
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#00AEEF'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(0,174,239,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    '&:hover': {
                                        backgroundColor: '#00AEEF',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                {/* Sentiment Filter */}
                {currentStep === 0 && (
                    <div className="form-field">
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Sentiment</h5>
                        <Select
                            options={[
                                { value: 'all', label: 'All' },
                                { value: 'positive', label: '😊 Positive' },
                                { value: 'negative', label: '😟 Negative' },
                                { value: 'neutral', label: '😐 Neutral' }
                            ]}
                            value={{ 
                                value: sentimentFilter, 
                                label: sentimentFilter === 'all' ? 'All' : 
                                       sentimentFilter === 'positive' ? '😊 Positive' : 
                                       sentimentFilter === 'negative' ? '😟 Negative' : '😐 Neutral'
                            }}
                            onChange={(selected) => {
                                dispatch(setSentimentFilter(selected ? selected.value : 'all'));
                            }}
                            placeholder="Filter by sentiment"
                            isClearable={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#00AEEF'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}
                
                {/* Checkboxes - Grouped Together */}
                {withSearchFields && currentStep === 0 && (
                    <div className="form-field" style={{marginTop: '10px'}}>
                        <label style={{display: 'block', marginBottom: '8px'}}>
                            <input
                                type="checkbox"
                                checked={excludeAlreadyMadeStories}
                                onChange={(e) => dispatch(setExcludeAlreadyMadeStories(e.target.checked))}
                                style={{marginRight: '10px', accentColor: '#FF6B35'}}
                            />
                            Hide completed stories
                        </label>
                        {/* "Show trending" moved up to sit directly under the
                            time-range box, since both answer "which slice of the
                            feed am I looking at", while these remaining boxes are
                            housekeeping. */}
                        <label style={{display: 'block'}}>
                            <input
                                type="checkbox"
                                checked={prs}
                                onChange={(e) => dispatch(setPrs(e.target.checked))}
                                style={{marginRight: '10px', accentColor: '#FF6B35'}}
                            />
                            PRs
                        </label>
                    </div>
                )}

                {/* Recent Queries - Always visible */}
                {currentStep === 0 && Array.isArray(queryHistory) && queryHistory.length > 0 && (
                    <div className="form-field" style={{ marginTop: '20px' }}>
                        <h5 style={{ marginBottom: '6px', fontSize: '11px', fontWeight: '600', color: '#0B1E3F', textTransform: 'uppercase', letterSpacing: '0.5px', fontFamily: "'Poppins', 'Inter', sans-serif" }}>Recent Searches</h5>
                        <Select
                            value={selectedQuery ? { value: selectedQuery._id, label: getQueryDisplayText(selectedQuery) } : null}
                            onChange={(opt) => {
                                const syntheticEvent = { target: { value: opt ? opt.value : '' } };
                                handleQuerySelect(syntheticEvent);
                            }}
                            options={(Array.isArray(queryHistory) ? queryHistory : []).map(query => ({
                                value: query._id,
                                label: getQueryDisplayText(query)
                            }))}
                            isClearable
                            placeholder="Select recent query..."
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderRadius: '10px',
                                    border: state.isFocused ? '1px solid #00AEEF' : '1px solid #e0e0e0',
                                    fontSize: '13px',
                                    minHeight: '38px',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #00AEEF',
                                        boxShadow: '0 0 0 2px rgba(0,174,239,0.1)'
                                    }
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    color: '#e0e0e0',
                                    padding: '6px',
                                    svg: { width: '16px', height: '16px', strokeWidth: '0.5px' },
                                    '&:hover': {
                                        color: '#00AEEF'
                                    }
                                }),
                                indicatorSeparator: () => ({ display: 'none' }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: '#999'
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: '#333',
                                    fontSize: '13px',
                                    '&:active': { backgroundColor: 'rgba(0,174,239,0.15)' }
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#333',
                                    fontSize: '13px'
                                }),
                            }}
                        />
                    </div>
                )}

                {/* Bottom actions: Toggle All + Reset All */}
                {currentStep === 0 && (
                    <div style={{ minHeight: '36px', marginTop: '12px', display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <button
                            type="button"
                            onClick={() => dispatch(triggerExpandAll())}
                            style={{
                                padding: '5px 12px',
                                background: 'none',
                                color: '#3C4A5E',
                                border: '1px solid rgba(60,74,94,0.15)',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                fontWeight: '500',
                                fontFamily: "'Inter', sans-serif",
                            }}
                        >
                            {storiesAllExpanded ? 'Collapse All' : 'Expand All'}
                        </button>
                        {!pristine &&
                            (selectedTimeRange !== 'Last 24 Hours' ||
                                selectedCategories.length > 0 ||
                                selectedLanguages.length !== languages.length ||
                                excludeLanguages.length > 0 ||
                                excludeCountries.length > 0 ||
                                extractKeywords(keywords).length > 0) && (
                            <button
                                type="button"
                                onClick={handleClearSearch}
                                style={{
                                    padding: '5px 12px',
                                    background: 'none',
                                    color: '#FF6B35',
                                    border: '1px solid rgba(255,107,53,0.25)',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    fontFamily: "'Inter', sans-serif",
                                }}
                            >
                                Reset All
                            </button>
                        )}
                    </div>
                )}

                {/* Advanced Search Section — hidden per design */}
                {false && currentStep === 0 && (
                    <div className="form-field" style={{ marginTop: '20px' }}>
                        <div
                            onClick={() => setIsAdvancedSearchOpen(!isAdvancedSearchOpen)}
                            style={{
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                color: '#00AEEF',
                                fontSize: '14px',
                                fontWeight: '500',
                            }}
                        >
                            Advanced Search {isAdvancedSearchOpen ? '−' : '+'}
                        </div>

                        {isAdvancedSearchOpen && (
                            <div style={{ 
                                marginTop: '15px',
                                padding: '15px',
                                backgroundColor: '#fafafa',
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                {/* Exclude Languages */}
                                {languages && languages.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ 
                                            fontSize: '14px', 
                                            color: '#3C4A5E', 
                                            marginBottom: '8px', 
                                            display: 'block',
                                            fontWeight: '600'
                                        }}>
                                            Exclude Languages
                                        </label>
                                        <Select
                                            isMulti
                                            options={languages.map(lang => ({ value: lang, label: lang }))}
                                            value={excludeLanguages.map(lang => ({ value: lang, label: lang }))}
                                            onChange={(selected) => {
                                                const values = selected ? selected.map(item => item.value) : [];
                                                dispatch(setExcludeLanguages(values));
                                            }}
                            placeholder="Search and select languages to exclude"
                            closeMenuOnSelect={false}
                            isClearable={false}
                            backspaceRemovesValue={false}
                            hideSelectedOptions={false}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '40px',
                                    borderRadius: '8px',
                                    border: '1px solid #ddd',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1px solid #aaa'
                                    }
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(0,174,239,0.08)',
                                    borderRadius: '4px'
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    fontWeight: '500'
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#00AEEF',
                                    '&:hover': {
                                        backgroundColor: '#00AEEF',
                                        color: 'white'
                                    }
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                    color: state.isSelected ? 'white' : '#333',
                                    '&:hover': {
                                        backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)'
                                    }
                                })
                            }}
                        />
                    </div>
                )}

                                {/* Verified by X Sources Filter */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ 
                                        fontSize: '14px', 
                                        color: '#3C4A5E', 
                                        marginBottom: '8px', 
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontWeight: '600'
                                    }}>
                                        <input
                                            type="checkbox"
                                            checked={verifiedBySourcesToggle}
                                            onChange={(e) => dispatch(setVerifiedBySourcesToggle(e.target.checked))}
                                            style={{
                                                width: '18px',
                                                height: '18px',
                                                cursor: 'pointer',
                                                accentColor: '#FF6B35'
                                            }}
                                        />
                                        Show only claims verified by multiple sources
                                    </label>
                                    {verifiedBySourcesToggle && (
                                        <div style={{ 
                                            marginTop: '10px',
                                            paddingLeft: '26px'
                                        }}>
                                            <label style={{ 
                                                fontSize: '13px', 
                                                color: '#3C4A5E', 
                                                marginBottom: '6px', 
                                                display: 'block'
                                            }}>
                                                Minimum number of sources:
                                            </label>
                                            <input
                                                type="number"
                                                min="2"
                                                max="10"
                                                value={minSourcesVerified}
                                                onChange={(e) => dispatch(setMinSourcesVerified(parseInt(e.target.value) || 2))}
                                                style={{
                                                    width: '80px',
                                                    padding: '8px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ddd',
                                                    fontSize: '14px'
                                                }}
                                            />
                                            <p style={{
                                                fontSize: '12px',
                                                color: '#999',
                                                marginTop: '6px',
                                                fontStyle: 'italic'
                                            }}>
                                                Claims cited by fewer than {minSourcesVerified} publishers will be hidden
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* Sort Stories By */}
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{
                                        fontSize: '14px',
                                        color: '#3C4A5E',
                                        marginBottom: '8px',
                                        display: 'block',
                                        fontWeight: '600'
                                    }}>
                                        Sort Stories By
                                    </label>
                                    <Select
                                        options={[
                                            { value: 'none', label: 'Default (by article count)' },
                                            { value: 'sentiment-high', label: 'Most Positive First' },
                                            { value: 'sentiment-low', label: 'Most Negative First' },
                                            { value: 'ranking-high', label: 'Highest Ranking First' },
                                            { value: 'shares-high', label: 'Most Shares First' },
                                            { value: 'recent', label: 'Most Recently Updated' },
                                            { value: 'earliest', label: 'First Published' }
                                        ]}
                                        value={{
                                            value: advancedSort,
                                            label: advancedSort === 'none' ? 'Default (by article count)' :
                                                   advancedSort === 'sentiment-high' ? 'Most Positive First' :
                                                   advancedSort === 'sentiment-low' ? 'Most Negative First' :
                                                   advancedSort === 'ranking-high' ? 'Highest Ranking First' :
                                                   advancedSort === 'shares-high' ? 'Most Shares First' :
                                                   advancedSort === 'recent' ? 'Most Recently Updated' :
                                                   'First Published'
                                        }}
                                        onChange={(selected) => {
                                            dispatch(setAdvancedSort(selected ? selected.value : 'none'));
                                        }}
                                        placeholder="Select sort order"
                                        isClearable={false}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                boxShadow: 'none',
                                                '&:hover': { border: '1px solid #aaa' }
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#00AEEF' : state.isFocused ? 'rgba(0,174,239,0.08)' : 'white',
                                                color: state.isSelected ? 'white' : '#333',
                                                '&:hover': { backgroundColor: state.isSelected ? '#00AEEF' : 'rgba(0,174,239,0.08)' }
                                            })
                                        }}
                                    />
                                </div>

                                {/* Expand All Stories */}
                                <div>
                                    <button
                                        type="button"
                                        onClick={() => dispatch(triggerExpandAll())}
                                        style={{
                                            width: '100%',
                                            padding: '10px 16px',
                                            background: '#f5f7fa',
                                            color: '#444',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        Expand All Stories
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Sort Stories By and Expand All moved into Advanced Search */}
                
                <div className="button-container">
                    {articlesNumber && currentStep === 1 && (
                        <div style={{fontSize: '20px'}}>
                            Showing <span style={{fontWeight: 'bold'}}>{articlesNumber}</span> articles for the selected
                            story
                        </div>
                    )}
                    {articlesNumber && currentStep === 2 && (
                        <div style={{fontSize: '20px'}}>
                            Showing <span style={{fontWeight: 'bold'}}>{claimsNumber}</span> claims extracted
                            from <span style={{fontWeight: 'bold'}}>{selectedArticles}</span> sources.
                        </div>
                    )}
                    {title1 && (
                        <div
                            ref={storyId ? titleDragRef : undefined}
                            style={{
                                fontWeight: 'bold',
                                fontSize: '24px',
                                marginTop: '20px',
                                cursor: storyId ? 'grab' : 'default',
                                opacity: isDraggingTitle ? 0.5 : 1,
                            }}
                            title={storyId ? 'Drag to a bucket in the sidebar' : undefined}
                        >
                            {title1}</div>
                    )
                    }
                    {/* The second copy of the "Include all story articles" toggle lived
                        here. Removed with the one in CreateBriefComponent (§4): every
                        article is visible now, matching first and non-matching below in
                        a muted group, so there is nothing for a toggle to reveal. */}

                </div>
            </div>
        </form>
    );
};

export default SearchFields;
